import { render, staticRenderFns } from "./IncreaseModal.vue?vue&type=template&id=35f03f3a&"
import script from "./IncreaseModal.vue?vue&type=script&lang=js&"
export * from "./IncreaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports